import Icon from '../components/Icon.vue'

Icon.register({"registered":{"width":512,"height":512,"paths":[{"d":"M285.4 207.5C285.4 226.1 275.5 235.9 256.9 235.9H227.1V179.8H250.4C279.1 179.8 285.4 188.5 285.4 207.5zM504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM363.4 360.4C316.7 275.6 320.1 281.8 318.7 279.4 342.1 264.3 356.7 236.5 356.7 204.9 356.7 150.7 325.2 115.7 251.2 115.7H180.5C167.2 115.7 156.5 126.4 156.5 139.7V372C156.5 385.3 167.2 396 180.5 396H203.1C216.3 396 227.1 385.3 227.1 372V300.3H252.6L296.7 383.3A24-24 0 0 1 317.9 396H342.4C360.7 396 372.2 376.4 363.4 360.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/registered.js
// module id = null
// module chunks = 